import React from 'react';
import { Composition } from 'remotion';
import { CoreEffectsCompositions } from './compositions/CoreEffectsCompositions';
import { ShowcaseCompositions } from './compositions/ShowcaseCompositions';
import { EarlyResearchCompositions } from './compositions/EarlyResearchCompositions';
import { Research2026Compositions } from './compositions/Research2026Compositions';
import { Latest2026Compositions } from './compositions/Latest2026Compositions';
import { PracticalCasesCompositions } from './compositions/PracticalCasesCompositions';
import { XHSTemplatesCompositions } from './compositions/XHSTemplatesCompositions';
import { XHSDataVisualizationCompositions } from './compositions/XHSDataVisualizationCompositions';
import { XHSEmotionalStoryCompositions } from './compositions/XHSEmotionalStoryCompositions';
import { XHSFastImpactCompositions } from './compositions/XHSFastImpactCompositions';
import { KnowledgeTemplatesCompositions } from './compositions/KnowledgeTemplatesCompositions';
import { EducationalEffectsCompositions } from './compositions/EducationalEffectsCompositions';
import { NewKnowledgeCompositions } from './compositions/NewKnowledgeCompositions';
import { CustomTemplatesCompositions } from './compositions/CustomTemplatesCompositions';
import { SubtitleTemplatesCompositions } from './compositions/SubtitleTemplatesCompositions';
import {HumanMouseDemo} from './effects/HumanMouseDemo';
import { HumanMouseTemplate, calculateTotalFrames } from './templates/HumanMouseTemplate';
import {fcCompatibilityCases} from './fc-compat/FcCompatibilityCases';

export const RemotionRoot: React.FC = () => {
  if (process.env.REMOTION_FC_COMPAT_ONLY === 'true') {
    return (
      <>
        {fcCompatibilityCases.map(({id, ...composition}) => (
          <Composition key={id} id={id} {...composition} />
        ))}
      </>
    );
  }

  return (
    <>
      {/* 🎨 核心效果库（过渡 / 文字 / 几何 / 渐变 / 故障 / 3D / 图片过渡） */}
      <CoreEffectsCompositions />

      {/* 🚀 效果展示（#81-#166，Beyond100 系列，媒体画廊） */}
      <ShowcaseCompositions />

      {/* 📚 早期 2026 研究 + 教育模板（#158-#192，教育 V2，物理/数学模板） */}
      <EarlyResearchCompositions />

      {/* 🔬 2026-03-04~05 研究效果（#267-#328，粒子/流体/音频/AI 动画） */}
      <Research2026Compositions />

      {/* ✨ 2026-03-06~08 最新效果 + 字幕（#338-#465，字幕合集） */}
      <Latest2026Compositions />

      {/* 📊 2026-03-10 实用案例（教育/商业/信息图表） */}
      <PracticalCasesCompositions />

      {/* 🎬 2026-03-11 小红书完整模板（产品对比 / 美食探店 / 好物分享） */}
      <XHSTemplatesCompositions />

      {/* 📊 2026-03-11 小红书爆款模板 - 数据可视化（收入对比/时间分配/成长数据） */}
      <XHSDataVisualizationCompositions />

      {/* ❤️ 2026-03-11 小红书爆款模板 - 情感故事（励志故事/成长经历/情感共鸣） */}
      <XHSEmotionalStoryCompositions />

      {/* ⚡ 2026-03-11 小红书爆款模板 - 快速冲击（技能速成/知识盘点/技巧合集） */}
      <XHSFastImpactCompositions />

      {/* 📖 2026-03-18 知识类视频模板（学术/技能/科普/生活/思维/心理学） */}
      <KnowledgeTemplatesCompositions />

      {/* 🎓 2026-03-18 教育效果合集（数学公式/心流状态/时间线/测验/数据可视化/语言学习/逻辑谜题） */}
      <EducationalEffectsCompositions />

      {/* 📚 2026-03-23 新增知识教育模板（热力学/集合论/修辞/Git/系统设计/敏捷/CRISPR/弦理论/微生物/时间管理/人体工程学/食品安全/第二大脑/费曼/心智模型/达克效应/安慰剂/斯德哥尔摩） */}
      <NewKnowledgeCompositions />

      {/* 🎥 用户自定义模板（点评视频） */}
      <CustomTemplatesCompositions />

      {/* 🔤 字幕效果模板（粗体描边/弹跳入场/高亮爆点光效） */}
      <SubtitleTemplatesCompositions />

      {/* 🎬 2026-03-17 真人鼠标移动效果演示 */}
      <Composition
        id="HumanMouseDemo"
        component={HumanMouseDemo}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
      />

      {/* 🎬 2026-03-17 通用真人鼠标效果模板 */}
      <Composition
        id="HumanMouseTemplate"
        component={HumanMouseTemplate}
        durationInFrames={300}
        fps={30}
        width={1920}
        height={1080}
        defaultProps={{
          background: 'baidu-screenshot.png',
          waypoints: [
            { x: 200, y: 200, action: 'move' },
            { x: 800, y: 400, action: 'click' },
            { x: 660, y: 395, action: 'type', text: '搜索内容' },
            { x: 1000, y: 450, action: 'click' }
          ],
          mouseSpeed: 5,
          showTrail: false
        }}
      />
    </>
  );
};
